import React from 'react';
import { Box, Skeleton } from '@mui/material';

function SourcesSkeleton() {
  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'space-between'}
      width={250}
      height={100}
      padding={'5px'}
      borderRadius={'12px'}
      border={'1px solid #EEEEEE'}
      bgcolor='white'
    >
      <Box>
        <Skeleton
          variant='rectangular'
          height={50}
          sx={{ borderRadius: '8px' }}
        />
        <Skeleton
          variant='rectangular'
          width={140}
          height={15}
          sx={{ marginTop: '5px', borderRadius: '8px' }}
        />
      </Box>
      <Box display={'flex'} alignItems={'center'}>
        <Skeleton
          variant='rectangular'
          width={18}
          height={22}
          sx={{ borderRadius: '5px' }}
        />
        <Skeleton
          variant='rectangular'
          width={170}
          sx={{ borderRadius: '8px', marginLeft: '8px' }}
        />
      </Box>
    </Box>
  );
}

export default SourcesSkeleton;
